import axios from 'axios'
import {config} from '@/api/config.js'

const behaviorService = axios.create({
  baseURL: config.behaviorUrl,
  timeout: 30000,
  headers: {}
})

const post = behaviorService.post
// article_title_id打点不能使用这个字段‘article_title_id’重要的事情说三遍使用必须用number 有隐藏bug
class Behavior {
  constructor() {
    this.baseUrl = config.behaviorUrl
    this.body = {
      "distinct_id": ``,
      "time": new Date().getTime(),
      "type": "track",
      "event": "ViewProduct",
      "project": 'wechat',
      "properties": {
        "project_name": "无项目",
        "channel": '',
        "app_version": navigator.appVersion,
        "province": "",
        "city": "",
        "user_agent": navigator.userAgent,
        "screen_width": window.screen.width,
        "screen_height": window.screen.height,
        "uid": 0,
        "username": '',
        "is_consultant": false,
        "is_invest": '',
        'nickname': '',
        'avatarUrl': ''
      }
    }
    this.properties = Object.keys(this.body.properties)
  }
  init(params = {}) {
    // console.log('params....', params.projectName)
    this.body.project = params.project || 'wechat'
    this.body.distinct_id = `track_${params.project}_${params.userId}`
    this.body.properties['province'] = params.province|| ''
    this.body.properties['city'] = params.city || ''
    this.body.properties['username'] = params.username || ''
    this.body.properties['uid'] = params.username || ''
    this.body.properties['is_consultant'] = !!+params.isConsultant
    this.body.properties['is_invest'] = params.isConsultant
    this.body.properties['nickname'] = params.nickname || null
    this.body.properties['avatarUrl'] = params.headImgUrl || null
    this.body.properties['project_name'] = params.projectName || '动态管理后台未配置'
    this.body.properties['channel'] = params.channel || ''
  }
  track(body = {}) {
    let fn = () => {
      let timer = setTimeout(() => {
        clearInterval(timer)
        if (this.body.properties.username) return this.doneTrack(body)
        fn()
      }, 200)
    }
    fn()
  }
  doneTrack(body = {}) {
    this.initTrack()
    const time = new Date().getTime()
    this.body.time = time
    this.body.event = body.eventName
    this.body.distinct_id = `track_${this.body.project}_${this.body.properties['uid']}`
    Object.assign(this.body.properties, body.properties || {})
    this.requestPost()
  }
  requestPost() {
    console.log('behavior-info------', this.body)
    post('', this.body).then(res => {
      console.log('Behavior--------', res)
    })
  }
  initTrack() {
    for(let p in this.body.properties) {
      if(this.properties.includes(p)) continue
      delete this.body.properties[p]
    }
  }
}

export default function (Vue) {
  Vue.prototype.$behavior = new Behavior()
}
